import React from 'react';
import { ListFieldSection } from '../../../Layout';
import { Field, TextOutput } from '../../../Core';
import { WorksheetsResultsMessagesSection } from '../../Core';

const ResultsSection: React.FC = () => (
  <>
    <WorksheetsResultsMessagesSection />
    <ListFieldSection>
      <Field input={<TextOutput />} name="Results.MoistureContentPercent" />
    </ListFieldSection>
  </>
);

export { ResultsSection };
export default ResultsSection;
